// /src/locations/locations_gen7.js
export default [
  "Starter",
  "Route 1 (Gras)",
  "Route 1 (Trainer-Schule)",
  "Hauholi City (Geschenk)",
  "Route 2 (Gras)",
  "Verdant Cavern (Prüfung)",
  "Route 3 (Gras)",
  "Mele-Mele Blumenmeer",
  "Tenkarat-Hügel",
  "Küste von Mele-Mele (Angeln/Surfen)",
  "Route 4 (Gras)",
  "Ohana-Farm (Gras)",
  "Route 5 (Gras)",
  "Brooklet Hill (Prüfung)",
  "Route 6 (Gras)",
  "Route 7 (Angeln/Surfen)",
  "Wela-Vulkanpark",
  "Route 8 (Gras)",
  "Schattendschungel (Prüfung)",
  "Route 9 (Angeln)",
  "Konikoni City (Geschenk)",
  "Digda-Tunnel",
  "Route 10 (Gras)",
  "Hokulani-Berg (Prüfung)",
  "Route 11 (Gras)",
  "Route 12 (Gras)",
  "Route 13 (Gras)",
  "Route 14 (Prüfung)",
  "Route 15 (Gras)",
  "Haina-Wüste",
  "Ruine des Lebens",
  "Route 16 (Gras)",
  "Ula-Ula Blumenmeer",
  "Eiland-Scan (Ula-Ula)",
  "Route 17 (Gras)",
  "Po'u (Yeti-Hügel)",
  "Aeether-Paradies (Event)",
  "Poni-Küste",
  "Poni-Wiesen (Gras)",
  "Poni-Weg",
  "Poni-Schlucht (Prüfung)",
  "Antike Stätte von Poni",
  "Poni-Küstenpfad",
  "Poni-Meerespfad (Surfen/Angeln)",
  "Baum des Lebens (Legendär)",
  "Eiland-Scan (Poni)",
  "Ultra-Wurmloch (Ultrabiest)",
  "Siegesstraße von Alola",
  "Pokémon-Liga",
  "Fossil-1",
  "Fossil-2",
  "Fossil-3",
  "Fossil-4",
  "Fossil-5",
  "Extra-1",
  "Extra-2",
  "Extra-3",
  "Extra-4",
  "Extra-5",
  "Shiny",
  "Mistmon of the Year"
];
